import { useContext, useEffect, useState } from "react";
import AuthContext from "../../servicos/autorizacao/AuthContex";
import { Navigate, NavLink } from "react-router-dom";
import logo from '../../img/svgs/logo-lev-milhas.svg';

const NavMenu = () => {
  const { user, logout } = useContext(AuthContext);
  const autorizado = user.role === 'root' || user.role === 'admin';
  // const autorizado2 = user.role === 'root' || user.role === 'admin' || user.role === 'master';
  const [carrinho, setCarrinho] = useState([]);
  // const [carrinhoProducao, setCarrinhoProducao] = useState([]);

  useEffect(() => {
    // Obtém o objeto carrinho armazenado na memória local
    let carrinhoJSON = localStorage.getItem('carrinho');

    // Converte o objeto JSON em um objeto JavaScript
    let carrinho = JSON.parse(carrinhoJSON);

    // Atualiza o estado do componente com o objeto carrinho
    setCarrinho(carrinho);
  }, []);

  const exit = () => {
    logout();
    <Navigate to="/login"></Navigate>
  }

  let activeStyle = {
    textDecoration: "underline #FF6900 3px",
  };

  return <>
    <div className="sticky-top pt-1 pb-4 nav-principal container-fluid mb-5" style={{ backgroundColor: '#f7f2ff' }}>
      <nav className="navbar navbar-expand-l mt-4 d-flex justify-content-evenly align-items-center nav-menu container rounded-5" style={{ backgroundColor: '#753BBD' }}>
        <NavLink to="/" style={({ isActive }) => isActive ? activeStyle : undefined}>
          <img src={logo} width="80px" alt="home" />
        </NavLink>
        <NavLink to="/Shopping" className='text-light' style={({ isActive }) => isActive ? activeStyle : undefined}>
          Produtos
        </NavLink>
        <NavLink to="/Historico" className="text-light" style={({ isActive }) => isActive ? activeStyle : undefined}>
          Histórico de Milhas
        </NavLink>
        <NavLink to="/MinhasSolicitacoes" className="text-light" style={({ isActive }) => isActive ? activeStyle : undefined}>
          Minhas Solicitações
        </NavLink>
       
        <NavLink to="/Perfil" className="text-light" style={({ isActive }) => isActive ? activeStyle : undefined}>
          Minha Conta
        </NavLink>
        {autorizado &&
          <NavLink to="/gerenciamento" className="text-light" style={({ isActive }) => isActive ? activeStyle : undefined}>
            Gerenciamento
          </NavLink>}

        <NavLink className="text-light" to="/CarrinhoSimples">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" className="bi bi-cart-check-fill ms-3" viewBox="0 0 16 16">
            <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708z" />
          </svg>{carrinho?.produtos?.length > 0 && <span style={{ marginTop: 20, color: '#FF6900', fontSize: 11 }}>{carrinho?.produtos?.length}</span>} <span className="text-light"></span>
        </NavLink>
        
        <NavLink className="text-light" onClick={() => exit()}>
          Logout
        </NavLink>
      </nav>
    </div>
  </>
}

export default NavMenu;